import { ThemeColors } from '../../theme';
import { useThemeColorVar } from '../use-theme-color-var';

export const useThemeColorPaletteVar = (palette: ThemeColors) => {
  const main = useThemeColorVar(`${palette}.main`);
  const dark = useThemeColorVar(`${palette}.dark`);
  const ultraDark = useThemeColorVar(`${palette}.ultra-dark`);
  const contrast = useThemeColorVar(`${palette}.contrast`);
  const light = useThemeColorVar(`${palette}.light`);
  const ultraLight = useThemeColorVar(`${palette}.ultra-light`);

  return {
    main,
    dark,
    'ultra-dark': ultraDark,
    contrast,
    light,
    'ultra-light': ultraLight,
  };
};
